package pl.decks.chartjs.radar.options

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.model.JSScriptableIndexable

data class GridOptions(
    val display: Boolean = true,
    val color: JSScriptableIndexable<ChartColor>? = null,
    val lineWidth: JSScriptableIndexable<Float>? = null,
    val circular: Boolean? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.display = display.asDynamic()
        if (color != null) this.color = color.toChartJs { it.toChartJs() }
        if (lineWidth != null) this.lineWidth = lineWidth.toChartJs { it.asDynamic() }
        if (circular != null) this.circular = circular.asDynamic()
    }
}
